// İsim/id'den deterministik, canlı bir avatar rengi üretir.
const PALETTE_SATURATION = 62;
const PALETTE_LIGHTNESS = 46;

export const hashString = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    hash |= 0;
  }
  return Math.abs(hash);
};

export const colorFromString = (seed: string | number): string => {
  const hue = hashString(String(seed)) % 360;
  return `hsl(${hue}, ${PALETTE_SATURATION}%, ${PALETTE_LIGHTNESS}%)`;
};

export const initialsOf = (name?: string, surname?: string): string => {
  const a = (name || '').trim();
  const b = (surname || '').trim();
  if (a && b) return (a[0] + b[0]).toUpperCase();
  if (a) return a.slice(0, 2).toUpperCase();
  return '?';
};
